<div class="loader">
  <div class="content" *ngFor="let n of nums; index as i">
    <content-loader viewBox="0 0 35 72">
      <svg:rect x="0" y="0" rx="0" ry="0" width="35" height="40" />
      <svg:rect x="0" y="41" rx="0" ry="0" width="10" height="11" />
      <svg:rect x="0" y="53" rx="0" ry="0" width="20" height="2" />
      <svg:rect x="0" y="56" rx="0" ry="0" width="25" height="2" />
      <svg:rect x="0" y="59" rx="0" ry="0" width="15" height="2" />
      <svg:rect x="25" y="62" rx="1" ry="1" width="10" height="10" />
      <svg:rect x="0" y="70" rx="0" ry="0" width="12" height="2" />
    </content-loader>
  </div>
</div>
